<div class="file-folder-wrapper">
  <div *ngIf="item.type=='filefolders'" class="file-folder-link" title="{{item.data?.title||item.id}}"><i style="color:#999;" class="far" [ngClass]="{'fa-folder': item !== active, 'fa-folder-open': item === active}"></i>&nbsp;<a class="file-folder" (click)="navigate(item)">{{item.data.title}}</a></div>
  <div *ngFor="let subitem of item.folders">
    <app-file-folder *ngIf="subitem.type=='filefolders'" [item]="subitem" (navigateItem)="navigate($event)" [active]="active"></app-file-folder>
  </div>
</div>
